import debounce from 'debounce';

// lang switcher
document.addEventListener('DOMContentLoaded', function () {
  class LangSwitcher extends HTMLElement {
    constructor() {
      super();
      // elements
      this.trigger = this.querySelector('.js-lang__trigger');
      this.list = this.querySelector('.js-lang__list');
    }
    connectedCallback() {
      // bindings
      this.bndOnClick = this.onClick.bind(this);
      this.bndOnScroll = debounce(this.onScroll.bind(this), 100);
      // events
      this.onLoad();
      document.addEventListener('click', this.bndOnClick);
      window.addEventListener('scroll', this.bndOnScroll);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.bndOnClick);
      window.removeEventListener('scroll', this.bndOnScroll);
    }
    onLoad() {}
    open() {
      this.list.removeAttribute('hidden');
      this.trigger.setAttribute('aria-expanded', 'true');
    }
    close() {
      this.list.setAttribute('hidden', 'true');
      this.trigger.setAttribute('aria-expanded', 'false');
    }
    onClick(e) {
      const trigger = e.target.closest('.js-lang__trigger');
      if (!trigger) {
        this.close();
        return;
      }
      e.preventDefault();
      const isClosed = this.list.getAttribute('hidden');
      if (isClosed) {
        this.open();
      } else {
        this.close();
      }
    }
    onScroll() {
      this.close();
    }
  }
  customElements.define('lang-switcher', LangSwitcher);
});